<div class="container-fluid otpverifyBgImg">
<div class="row registerArea">
	<div class="col-lg-4 offset-lg-4">
		<div class="card p-4 otp_form">
			<form method="post">
				<div class="text-center">
					<h4>Enter OTP</h4>
				</div>
				<div class="form-group pt-4 text-center">
					<label>OTP has been sent to +91 74xxxxxx87</label>
					<div class="row mt-3">
					<input type="number" name="otp1" class="form-control otp_input col-lg-2 mr-1 ml-5" required="required" onKeyPress="if(this.value.length==1) return false;">
					<input type="number" name="otp2" class="form-control otp_input col-lg-2 mx-1" required="required" onKeyPress="if(this.value.length==1) return false;">
					<input type="number" name="otp3" class="form-control otp_input col-lg-2 mx-1" required="required" onKeyPress="if(this.value.length==1) return false;">
					<input type="number" name="otp4" class="form-control otp_input col-lg-2 mr-1" required="required" onKeyPress="if(this.value.length==1) return false;">
				</div>
				</div>
				<input type="submit" name="submit" class="form-control btn btn-primary my-3" value="Verify">
			</form>
			<p class="text-center mt-3">Didn't received the otp? <a href="#"><img src="/assets/image/replay.svg" width="15"> Resend</a></p>
			<p class="text-center text-primary mt-4">Expires in  02:36 s </p>
		</div>
	</div>
</div>
</div>


